import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { UrlTree } from '@angular/router';
import { UserService } from '../service/user-service';
import { OpenIdService } from '../service/open-id.service';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class OpenIdGuard implements CanActivate {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private openIdService: OpenIdService,
        private router: Router
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.openIdService.$bearerToken.pipe(
            map((token: string) => {
                if (!token) {
                    this.router.navigate(['login']);
                    return false;
                }
                return true;
            })
        );
    }
}
